import { render } from "./SurveyWizardStep.vue?vue&type=template&id=0053277f&scoped=true"
import script from "./SurveyWizardStep.vue?vue&type=script&lang=js"
export * from "./SurveyWizardStep.vue?vue&type=script&lang=js"

import "./SurveyWizardStep.vue?vue&type=style&index=0&id=0053277f&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0053277f"]])

export default __exports__